import BN from 'bignumber.js'
import dayjs from 'dayjs'

export class Tools {
  /**
   * 地址省略
   * @param value 地址
   * @returns
   */
  static captureAddress (value: string, len = 4) {
    return value.replace(/^(0x)(.*)/, (v1, v2, v3) => {
      const ellipsis = `${v3.substr(0, len)}...${v3.substr(-len, len)}`

      return `${v2}${ellipsis}`
    })
  }

  /**
   * 为数字补全位数
   * @param num 数字
   * @param len 长度
   */
  static numFillZero (num: number, len = 2) {
    return num.toString().padStart(len, '0')
  }

  /**
   * 金额 - 加精度处理
   * @param amount 金额
   * @param decimal 精度
   * @returns
   */
  static amountPlusDecimal (amount: string, decimal: number) {
    return new BN(amount).times(new BN(10).exponentiatedBy(decimal)).toString()
  }

  /**
   * 金额 - 去除精度处理
   * @param amount 金额
   * @param decimal 精度
   * @returns
   */
  static amountDivDecimal (amount: string, decimal: number) {
    const BIG = BN

    BIG.set({ DECIMAL_PLACES: 2, ROUNDING_MODE: 1 })

    return new BIG(amount).div(new BIG(10).exponentiatedBy(decimal)).toString()
  }

  /**
   * 格式化时间戳
   * @param timestamp 时间戳
   * @param format 格式
   * @returns
   */
  static timeFormat (timestamp: number, format = 'MMM-DD HH:mm') {
    return dayjs(timestamp).format(format).valueOf()
  }

  /**
 * 显示用数值规范
 * @param num {String}
 * @param {number} [round] - 小数取整方式 0-向上取整 1-向下取整
 * @return {string|*}
 */
  static getShowNumByNum (num: string, round: any = 1) {
    if (typeof num === 'string' && num === '') return '~'

    let intNum = ''
    let float = ''
    if (num.indexOf('.') !== -1) {
      const numArray = num.split('.')
      intNum = numArray[0]
      float = numArray[1]
    } else {
      intNum = num
    }
    // 如果 整数位+小数位 <= 8，显示全部数字
    if (intNum.length + float.length <= 8) {
      const SmallBN = BN.clone({
        DECIMAL_PLACES: 7,
        ROUNDING_MODE: round
      })
      return new SmallBN(new SmallBN(num).toString(10)).toFormat()
    }
    // 如果 整数位+小数位 > 8
    // 如果 整数位 < 8 显示全部整数 小数补到一共8位
    if (intNum.length < 8) {
      const floatBit = 8 - intNum.length
      const FixedBN = BN.clone({
        DECIMAL_PLACES: floatBit,
        ROUNDING_MODE: round
      })
      return new FixedBN(
        new FixedBN(intNum + '.' + float).toString(10)
      ).toFormat()
    }
    // 如果 整数位 = 8 只显示整数
    const NoDecimalBN = BN.clone({
      DECIMAL_PLACES: 0,
      ROUNDING_MODE: round
    })
    if (intNum.length === 8) {
      return new NoDecimalBN(
        new NoDecimalBN(intNum + '.' + float).toString(10)
      ).toFormat()
    }
    const IntBN = BN.clone({
      DECIMAL_PLACES: 2,
      ROUNDING_MODE: round
    })
    // 如果 10 > 整数位 > 8  整数缩小6位 最后加M 保留2位有效小数
    if (intNum.length > 8 && intNum.length < 10) {
      return (
        new IntBN(new IntBN(intNum).div(1000000).toString(10)).toFormat() + 'M'
      )
    }
    // 如果 整数位 >= 10 整数缩小9位 最后加B 保留2位有效小数
    if (intNum.length >= 10) {
      return (
        new IntBN(new IntBN(intNum).div(1000000000).toString(10)).toFormat() + 'B'
      )
    }
  }
}
